import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiShield, FiExternalLink } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-20 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-16 mb-16">
          {/* Brand & Address */}
          <div>
            <div className="text-2xl font-black mb-8 tracking-tighter">
              GROUPE <span className="text-[#00a48c]">VAILLANCE CONSEIL</span>
            </div>
            <div className="space-y-4 text-gray-400 font-bold text-sm">
              <div className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="mt-1 text-[#00a48c]" />
                <span>25 rue de Ponthieu, 75008 Paris, France</span>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="text-[#00a48c]" />
                <span>01 71 19 96 36</span>
              </div>
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="text-[#00a48c]" />
                <span>m.saad@groupevaillance.fr</span>
              </div>
            </div>
          </div>

          {/* Legal Info */}
          <div className="md:col-span-2 grid sm:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="font-black uppercase text-xs tracking-[0.2em] text-[#00a48c] mb-6">Informations Légales</h3>
              <div className="grid grid-cols-1 gap-3 text-xs font-bold text-gray-500 uppercase tracking-widest">
                <p>Société par actions simplifiée</p>
                <p>N° ORIAS : 07030598</p>
                <p>N° SIREN : 498 733 104</p>
                <p>Code NAF : 6622Z</p>
                <p>RCS : Paris</p>
              </div>
              
              {/* Liens Juridiques */}
              <div className="pt-6 flex flex-wrap gap-x-6 gap-y-3 border-t border-white/5">
                <a href="/mentions-legales" className="text-[10px] font-black text-gray-400 hover:text-[#00a48c] transition-colors uppercase tracking-widest">Mentions Légales</a>
                <a href="/politique-confidentialite" className="text-[10px] font-black text-gray-400 hover:text-[#00a48c] transition-colors uppercase tracking-widest">Confidentialité</a>
                <a href="/cgu" className="text-[10px] font-black text-gray-400 hover:text-[#00a48c] transition-colors uppercase tracking-widest">CGU</a>
                <a href="/cookies" className="text-[10px] font-black text-gray-400 hover:text-[#00a48c] transition-colors uppercase tracking-widest">Cookies</a>
              </div>
            </div>

            <div className="space-y-6">
              <h3 className="font-black uppercase text-xs tracking-[0.2em] text-[#00a48c] mb-6">Liens Utiles</h3>
              <div className="flex flex-col gap-4">
                <a href="https://www.groupevaillanceconseil.fr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm font-bold text-white hover:text-[#00a48c] transition-colors">
                  <SafeIcon icon={FiExternalLink} /> www.groupevaillanceconseil.fr
                </a>
                <div className="bg-white/5 p-4 rounded-2xl border border-white/10">
                  <div className="flex items-center gap-2 mb-2">
                    <SafeIcon icon={FiShield} className="text-[#00a48c]" />
                    <span className="text-[10px] font-black uppercase tracking-widest">Conseil Certifié</span>
                  </div>
                  <p className="text-[9px] text-gray-500 leading-relaxed font-bold">
                    Les investissements sur un PER comportent un risque de perte en capital. Les performances passées ne préjugent pas des performances futures.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 pt-8 text-center text-[10px] font-black text-gray-600 uppercase tracking-[0.4em]">
          <p>Simulation-rendement-PER© 2026 - Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;